import React from "react";
import styled from "styled-components";
import Viewmore from "@src/components/Viewmore";
import { down, only, up } from "styled-breakpoints";
import trimLeading from "@src/utils/trimLeading";
import settings from "@src/settings";
import getGridHeight from "@src/utils/getGridHeight";

export const TextFrame = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	${down("md")} {
		flex: 1 1 auto;
		& > ${Viewmore} {
			margin-top: 36px;
		}
	}
	${down("xs")} {
		& > ${Viewmore} {
			margin-top: ${getGridHeight({
				rows: 1,
				withTopGap: true,
				withBottomGap: true,
			})}px;
		}
	}
`;
export const Index = styled.div`
	display: flex;
	align-items: center;
`;
export const IndexNum = styled.p`
	font-weight: 600;
	font-style: normal;
	font-family: ${settings.font.en};
	color: ${settings.color.main};
	letter-spacing: 0.88px;
	${trimLeading({ fontSize: 32, lineHeight: 32, font: "montserrat" })}
`;
export const IndexType = styled.p`
	font-weight: 500;
	font-style: normal;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	letter-spacing: 1.95px;
	${trimLeading({ fontSize: 16, lineHeight: 16 * 1.2 })}
	${IndexNum} + & {
		border-left: 1px solid ${settings.color.main};
		margin-left: 15px;
		padding-left: 15px;
	}
`;
export const Titles = styled.div`
	${down("md")} {
		${Index} + & {
			margin-top: 2rem;
		}
	}
	${down("xs")} {
		${Index} + & {
			margin-top: ${getGridHeight({ rows: 1, withTopGap: true }) + 4}px;
		}
	}
`;
export const Lead = styled.div`
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	font-weight: 700;
	letter-spacing: 3px;
	white-space: pre-line;
	${trimLeading({ fontSize: 21, lineHeight: 42.95 })}
	${only("md")} {
		white-space: normal;
	}
`;
export const StaffInfoCont = styled.div`
	display: flex;
	${Lead} + & {
		margin-top: 27px;
	}
	${down("xs")} {
		${Lead} + & {
			margin-top: ${getGridHeight({ rows: 1, withTopGap: true }) + 2}px;
		}
	}
`;
export const StaffInfo = styled.div`
	& + & {
		margin-left: 16px;
	}
`;
export const StaffPosition = styled.p`
	font-weight: 700;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	letter-spacing: 0.2222px;
	${trimLeading({ fontSize: 14, lineHeight: 16.8 })}
`;
export const StaffName = styled.p`
	font-weight: 700;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	letter-spacing: 2.53px;
	${trimLeading({ fontSize: 18.2857, lineHeight: 18.2857 * 1.2 })}
	${StaffPosition} + & {
		margin-top: 9px;
	}
`;
export const StaffRuby = styled.p`
	font-weight: 400;
	font-family: ${settings.font.en};
	color: ${settings.color.main};
	font-size: 10px;
	letter-spacing: 1.41px;
	line-height: 1.2;
	${trimLeading({ fontSize: 10, lineHeight: 12, font: "montserrat" })}
	${StaffName} + & {
		margin-top: 12px;
	}
`;
